import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Users from './pages/Users';
import Knowledgebase from './pages/Knowledgebase';
import Books from './pages/Books';
import QuestionBank from './pages/QuestionBank';
import Specialities from './pages/Specialities';
import SubSpecialities from './pages/SubSpecialities';
import QuestionTypes from './pages/QuestionTypes';
import Colleges from './pages/Colleges';
import Exams from './pages/Exams';
import CreditPricing from './pages/CreditPricing';
import ContactSubmissions from './pages/ContactSubmissions';
import FeedbackSubmissions from './pages/FeedbackSubmissions';
import MessageFeedbackAnalytics from './pages/MessageFeedbackAnalytics';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check session on app load
  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await axios.get('/api/auth/check', {
        withCredentials: true
      });

      if (response.data.authenticated) {
        setUser(response.data.user);
      }
    } catch (error) {
      console.error('Session check error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
  };

  if (loading) {
    return (
      <div className="App loading">
        <div className="loader">Loading...</div>
      </div>
    );
  }

  const ProtectedRoute = ({ children }) => {
    return user ? (
      <Layout user={user} onLogout={handleLogout}>
        {children}
      </Layout>
    ) : (
      <Navigate to="/login" />
    );
  };

  return (
    <Router>
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/knowledgebase"
            element={
              <ProtectedRoute>
                <Knowledgebase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/books"
            element={
              <ProtectedRoute>
                <Books />
              </ProtectedRoute>
            }
          />
          <Route
            path="/question-bank"
            element={
              <ProtectedRoute>
                <QuestionBank />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/specialities"
            element={
              <ProtectedRoute>
                <Specialities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/sub-specialities"
            element={
              <ProtectedRoute>
                <SubSpecialities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/question-types"
            element={
              <ProtectedRoute>
                <QuestionTypes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/colleges"
            element={
              <ProtectedRoute>
                <Colleges />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/exams"
            element={
              <ProtectedRoute>
                <Exams />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/credit-pricing"
            element={
              <ProtectedRoute>
                <CreditPricing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact-submissions"
            element={
              <ProtectedRoute>
                <ContactSubmissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback-submissions"
            element={
              <ProtectedRoute>
                <FeedbackSubmissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/message-feedback-analytics"
            element={
              <ProtectedRoute>
                <MessageFeedbackAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={<Navigate to={user ? "/dashboard" : "/login"} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
